<!-- <app-inner-content [content]="parent.node?.content"></app-inner-content> -->

<app-research-card [card]="userResearch"></app-research-card>
